function wishlistPage() {
  document.querySelectorAll(".js-add-to-wishlist").forEach(function (el) {
    var productHandle = el.getAttribute("data-product-handle") + ",";
    var wishlist = localStorage.getItem('wishlist') || '';
    if (wishlist.indexOf(productHandle) >= 0) {
      var icon = el.querySelector("svg");
      var span = el.querySelector("span");
      if (icon) icon.classList.add("filled");
      if (span) span.textContent = el.getAttribute("data-added");
    }
  });

  document.body.addEventListener("click", function (e) {
    var target = e.target.closest(".js-add-to-wishlist");
    if (target) {
      var icon = target.querySelector("svg");
      if (icon && !icon.classList.contains("filled")) {
        var productHandle = target.getAttribute("data-product-handle");
        if (icon) icon.classList.add("filled");
        var span = target.querySelector("span");
        if (span) span.textContent = target.getAttribute("data-added");

        var getWishlistProducts = localStorage.getItem('wishlist') || '';
        getWishlistProducts = getWishlistProducts.replace(productHandle + ",", "");
        localStorage.setItem('wishlist', getWishlistProducts + productHandle + ",");
        e.preventDefault();
      }
    }
  });

  document.body.addEventListener("click", function (e) {
    const btn = e.target.closest(".js-add-all-to-wishlist");
    if (!btn) return;

    e.preventDefault();
    if (btn.classList.contains("added")) return;

    btn.classList.add("added");
    const addedText = btn.getAttribute("data-added");
    if (addedText) btn.textContent = addedText;

    const fbtItems = document.querySelectorAll(".js-frequently-bought-together-product");
    let wishlist = localStorage.getItem("wishlist") || "";

    fbtItems.forEach((el) => {
      const handle = el.getAttribute("data-product-handle");
      if (!handle) return;

      wishlist = wishlist.replace(handle + ",", "");
      wishlist += handle + ",";

      document.querySelectorAll(`.js-add-to-wishlist[data-product-handle="${handle}"]`).forEach((wBtn) => {
        const icon = wBtn.querySelector("svg");
        const span = wBtn.querySelector("span");
        if (icon) icon.classList.add("filled");
        if (span) span.textContent = wBtn.getAttribute("data-added") || span.textContent;
      });
    });

    localStorage.setItem("wishlist", wishlist);

    const wishlistCount = wishlist.split(",").filter(Boolean).length;
    const countEl = document.querySelector(".js-wishlist-count");
    if (countEl) countEl.textContent = wishlistCount;
  });

  var wishlistBody = document.querySelector(".js-wishlist-body");
  if (wishlistBody) {
    var wishlist = localStorage.getItem('wishlist') || '';
    var wishlistContent = '';

    if (wishlist !== '') {
      var wishlistProducts = wishlist.split(",");
      wishlistProducts.forEach(function (handle) {
        if (handle !== '') {
          fetch('/products/' + handle + '.js')
            .then(response => response.json())
            .then(product => {
              var first_column = '<td><div class="wishlist__product"><div class="wishlist-product__image"><a href="' + product.url + '"><img alt="Image" src="' + product.featured_image + '" /></a></div><h3 class="wishlist-product__title"><a href="' + product.url + '">' + product.title + '</a></h3></div></td>';
              var second_column = '<td><div class="wishlist-product__price">' + Shopify.formatMoney(product.price) + '</div></td>';
              var third_column = product.available
                ? '<td><div class="wishlist-product__status wishlist-product__status--in-stock">' + wishlistBody.getAttribute("data-in-stock") + '</div></td>'
                : '<td><div class="wishlist-product__status wishlist-product__status--stock-out">' + wishlistBody.getAttribute("data-out-of-stock") + '</div></td>';
              var fourth_column = '<td><a href="' + product.url + '" class="fourth-button">' + wishlistBody.getAttribute("data-add-to-cart") + '</a></td>';
              var fifth_column = '<td><div class="wishlist-product__delete"><a href="#" class="js-delete-product-wishlist" data-product-handle="' + product.handle + '"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="lnil lnil-close" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg></a></div></td>';

              wishlistContent += '<tr>' + first_column + second_column + third_column + fourth_column + fifth_column + '</tr>';
            });
        }
      });
    }

    setTimeout(function () {
      if (wishlistContent === '') {
        wishlistContent = '<tr><td colspan="5">' + wishlistBody.getAttribute("data-wishlist-empty") + '</td></tr>';
      }
      wishlistBody.innerHTML = wishlistContent;
    }, 1000);

    document.body.addEventListener("click", function (e) {
      var target = e.target.closest(".js-delete-product-wishlist");
      if (target) {
        e.preventDefault();
        var tr = target.closest("tr");
        if (tr) tr.remove();

        var productHandle = target.getAttribute("data-product-handle");
        var getWishlistProducts = localStorage.getItem('wishlist') || '';
        getWishlistProducts = getWishlistProducts.replace(productHandle + ",", "");
        localStorage.setItem('wishlist', getWishlistProducts);
      }
    });
  }

  var wishlist = localStorage.getItem('wishlist') || '';
  var wishlistCounter = wishlist.split(",").length - 1;
  if (wishlistCounter < 0) wishlistCounter = 0;
  var countEl = document.querySelector(".js-wishlist-count");
  if (countEl) countEl.textContent = wishlistCounter;
}

document.addEventListener("DOMContentLoaded", function () {
  wishlistPage();
});